// extracted by mini-css-extract-plugin
export default {"task_submission__container":"styles_task_submission__container__T5825","form__section--head":"styles_form__section--head__R-+NV"};